import React, { FC } from 'react';
import * as classes from './SocialIconsWrapper.module.scss';

const SocialIconsWrapper: FC = ({ children }) => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.socialIcons}>{children}</div>
    </div>
  );
};

export default SocialIconsWrapper;
